import { render, staticRenderFns } from "./IconRectSolid.vue?vue&type=template&id=2cafb283&"
import script from "./IconRectSolid.vue?vue&type=script&lang=js&"
export * from "./IconRectSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports